:host {
  display: inline-flex;
  height: 100%;
  width: 100%;
  position: relative;

  --search-height: 56px;

  @include media-min(md) {
    --search-height: 100%;
  }
}

.search-toggle {
  background: none;
  border: none;
  padding: 0;
  height: var(--search-height);
  width: var(--search-height);
  display: grid;
  place-content: center;
  cursor: pointer;
  background-color: $color-turquoise-01;
  z-index: 1;

  &.is-active {
    z-index: 0;
  }

  &:focus-visible {
    outline: 2px solid $color-dark-blue-02;
    outline-offset: -12px;

    @include media-min(md) {
      outline-offset: -24px;
    }
  }

  @include media-min(xl) {
    display: none;
  }
}

.search-container {
  height: 0;
  overflow: hidden;
  position: absolute;
  top: 100%;
  right: 0;
  width: 100vw;
  transition:
    height 0.3s ease,
    overflow 0.3s ease;
  transition-behavior: allow-discrete;

  @include media-min(md) {
    transition: width 0.3s ease;
    height: var(--search-height);
    top: 0;
    width: 100%;
  }

  &.is-active {
    height: var(--search-height);
    overflow: visible;

    @include media-min(md) {
      height: var(--search-height);
      width: var(--search-expand-size, 50%);
    }

    input {
      font-size: 16px;
      font-weight: bold;

      &::placeholder {
        font-size: 12px;
        line-height: 20px;
        font-weight: normal;
      }
    }
  }

  .search-input-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;

    @include media-min(md) {
      position: relative;
    }
  }

  input {
    width: 100%;
    height: 100%;
    padding-block: 16px;
    padding-inline: 60px;
    border: 0;
    border-radius: 0;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    outline: none;
    font-family: 'Bosch Sans';
    background-color: $color-turquoise-01;
    color: $color-black;
    box-sizing: border-box;
    transition: font-size 0.3s ease;

    @include media-min(md) {
      padding-block: 23px;
      padding-inline: 60px;
    }

    //placeholder color
    &::placeholder {
      color: $color-black;
    }

    &::selection {
      background-color: $color-turquoise-02;
    }

    // remove/hide x button for search input
    &[type='search']::-webkit-search-decoration,
    &[type='search']::-webkit-search-cancel-button,
    &[type='search']::-webkit-search-results-button,
    &[type='search']::-webkit-search-results-decoration {
      -webkit-appearance: none;
      appearance: none;
    }
  }

  .search-icon {
    height: 32px;
    width: 32px;
    position: absolute;
    left: 24px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-dark-blue-02;
    border-radius: 0;

    &:focus-visible {
      outline: 2px solid $color-dark-blue-02;
    }

    @include media-min(md) {
      left: 24px;
    }

    @include media-min(lg) {
      left: 24px;
    }
  }

  .close-button {
    height: 32px;
    width: 32px;
    position: absolute;
    right: 24px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-black;
    border-radius: 0;

    &:focus-visible {
      outline: 2px solid $color-dark-blue-02;
    }
  }
}

@include autocomplete-results-container(48px);
